

<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>BSc Data Science </h1>
                </div>
            </div>
        </div>          
    </div>  
</section>    
<section class="section-lg std-scholarship">
    <div class="container">
        <div class="row row-50">
            <div class="col-md-3">
                <div class="vertical-tabs">
                    <ul class="nav nav-pills flex-column" id="myTab" role="tablist"> 
                        <li class="nav-item">
                            <a class="nav-link active" id="tab7-tab" data-toggle="tab" href="#tab7" role="tab" aria-controls="tab7" aria-selected="true">Overview  </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab8-tab" data-toggle="tab" href="#tab8" role="tab" aria-controls="tab8" aria-selected="false">Learnings</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab1-tab" data-toggle="tab" href="#tab1" role="tab" aria-controls="tab1" aria-selected="true">Eligibility Criteria </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab2-tab" data-toggle="tab" href="#tab2" role="tab" aria-controls="tab2" aria-selected="false">Duration</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab3-tab" data-toggle="tab" href="#tab3" role="tab" aria-controls="tab3" aria-selected="false">Subjects</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab4-tab" data-toggle="tab" href="#tab4" role="tab" aria-controls="tab4" aria-selected="false">Affiliation</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab5-tab" data-toggle="tab" href="#tab5" role="tab" aria-controls="tab5" aria-selected="false">Scope  and Prospects</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab6-tab" data-toggle="tab" href="#tab6" role="tab" aria-controls="tab6" aria-selected="false">Fees And Intake</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-md-9">
                <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="tab7" role="tabpanel" aria-labelledby="tab7-tab">
                        <div class="inner-title"  >
                            <h3>Overview</h3>                           
                           
                        </div>
                        <div class="text-left">
                            <p>The Bachelor of Data Science is a 3-year full-time undergraduate program designed to prepare graduates who can conduct data-driven investigations and visual and advanced analytics by acquiring and managing data of all types. Our rigorous curriculum, combined with hands-on training through capstone projects, workshops and internships, will help you build the industry-relevant skills you need to become job-ready. The duration of B.Sc. Data Science is three years, isolated into six semesters, which are full time for the most part.</p>
                        </div>
                    </div>

                    <div class="tab-pane fade " id="tab8" role="tabpanel" aria-labelledby="tab8-tab">   
                        <div class="inner-title"  >
                            <h3>	Learnings   </h3>                           
                           
                        </div>
                        <div class="text-left">
                            <h5 class="mb-3">Upon completing the program, you will be:</h5>
                            <ul >
                                <li>Equipped to fill the need for data expertise in diverse fields like IT, Consulting, BFSI, Healthcare, Education, Retail & Media.</li>
                                <li>Well-positioned for careers in data mining, data modelling, data architecture, extraction, transformation, loading development and business intelligence development.</li>
                                <li>Able to apply for roles like Data Scientist, Data Architect, Business Analyst, Developer, Consultant, Statistician and more.</li>
                              </ul>
                        </div>

                    </div>

                    <div class="tab-pane fade " id="tab1" role="tabpanel" aria-labelledby="tab1-tab">
                        <div class="inner-title"  >
                            <h3>Eligibility   </h3>                           
                           
                        </div>
                        <div class="text-left">
                            <p>The candidate should have passed the 12th Standard Examination of the Maharashtra State Board of Secondary and Higher Secondary Education with English and other Modern Indian Languages together with any three Science subjects comprised in the faculty of Science with Mathematics or an examination recognized as equivalent thereto in such subjects and with such standards of attainments as may be prescribed.</p>
                        </div>

                    </div>

                    <div class="tab-pane fade" id="tab2" role="tabpanel" aria-labelledby="tab2-tab">                                
                        <div class="inner-title"  >
                            <h3>Degree of Bachelor of Science (Data Science)<br/>(Three Years Degree Course – Semester Pattern) </h3>
                           
                        </div>  
                        <div class="text-left">                        
                            <p>The following shall be the examination leading to the Degree of Bachelor of Science (Data Science) in the faculty of Science namely:</p>
                        
                            <ul>
                                <li>The B.Sc. Semester-I Examination; </li>
                                <li>The B.Sc. Semester-II Examination;</li>
                                <li>The B.Sc. Semester-III Examination;</li> 
                                <li>The B.Sc. Semester-IV Examination; </li>
                                <li>The B.Sc. Semester-V Examination; and</li>
                                <li>The B.Sc. Semester-VI Examination.</li>
                            </ul>
                            <p class="mt-4">The period of Academic Session shall be such, as may be notified by the University.</p>
                            <p>The theory examination of Semester-I, II, III, IV, V and VI shall be conducted by the University and shall be held separately at the end of each semester at such places and dates as may be decided by the University and shall be held as per the schedule given in Table.</p>
                           
                            <div class="table-responsive" > 
                                <table class="table table-bordered text-center tbl_custom">
                                        <thead>
                                            <tr>
                                                <th colspan="4">Table</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Sr. No.</td>
                                                <td>Name of the Examination</td>
                                                <td>Main Examination</td>
                                                <td>Supplementary Examination</td>
                                            </tr>
                                            <tr>
                                                <td>1.</td>
                                                <td>Semester I, III, and V</td>
                                                <td>Winter,</td>
                                                <td>Summer</td>
                                            </tr>
                                            <tr>
                                                <td>2.</td>
                                                <td>Semester II, IV, and VI</td>
                                                <td>Summer</td>
                                                <td>Winter</td>
                                            </tr>
                                        </tbody>
                                </table>
                            </div>
                        
                        </div>
                    </div>

                    <div class="tab-pane fade" id="tab3" role="tabpanel" aria-labelledby="tab3-tab">                                
                        <div class="inner-title"  >
                            <h3>B.Sc.(Data Science)Three-Year (6-Semester) <br/>CBCS Programme Course Structure
                                
                            </h3>
                           
                        </div>

                         <ul class="list-item link-list">
							<li><a href="https://drive.google.com/file/d/114VMhDqcSuxwIEGWYOQsxL_kRWmLzhDm/view?usp=sharing" target="_blank" >BSc Data Science</a></li>
							
						</ul> 
                    </div>
                    <div class="tab-pane fade" id="tab4" role="tabpanel" aria-labelledby="tab4-tab">                                
                        <div class="inner-title"  >
                            <h3>Affiliation
                            </h3>
                           
                        </div> 
                        <div class="text-left">                         
                            <p>RTM Nagpur University, Nagpur </p>
                        </div> 
                    </div>
                    <div class="tab-pane fade" id="tab5" role="tabpanel" aria-labelledby="tab5-tab">                                
                        <div class="inner-title"  >
                            <h3>Scope  and Prospects
                            </h3>
                           
                        </div> 
                        <ul class="list-item"> 
                            <li><strong>Scope :</strong>MCA, MSc Data Science, MSc Computer Science, MSc Information Technology,</li>
                            <li><strong>Prospects / Scope :</strong>Investment Banker, Financial Analyst ,Statistician</li>
                        </ul>
                    </div>
                 
                    <div class="tab-pane fade" id="tab6" role="tabpanel" aria-labelledby="tab6-tab">                                
                        <div class="inner-title"  >
                            <h3>Fees And Intake
                            </h3>
                           
                        </div> 
                        <ul class="list-item"> 
                            <li><strong>Fees  :</strong> : INR 45,000/- per year</li>
                            <li><strong>Intake :</strong>: 120 students </li>
                        </ul>
                    </div>  
            </div>            
                <div class="text-center mt-5">
                    <a class="button-text" href="https://raisoni.nopaperforms.com/rgi" target="_blank">Apply Now</a>
                </div>
            </div>
        </div>
    </div>
</section>

